
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Portabilty_FPS_List from './Portabilty_FPS_List';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function PortabilityFpsTable({ selectedMonth, selectedYear, afsoCode, distCode, onDataLoaded }) {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [renderContent, setRenderContent] = useState(null);
      const [error, setError] = useState(null);
      const detailsRRef = useRef(null);

    const nextTableRef = useRef(null);
    const currentTableRef = useRef(null);

    const schemeHeaders = data.length > 0 ? data[0].schemeList || [] : [];

    useEffect(() => {
        if (!selectedMonth || !selectedYear || !afsoCode) return;

        setLoading(true);
        setRenderContent(null);

        axios.post(`${process.env.REACT_APP_URL_SIDE}/PortabilityAbstract/Portabilty_FPS`, {
            month: selectedMonth,
            year: selectedYear,
            distCode,
            afsoCode
        })
            .then(response => {
                setLoading(false);
                if (response.data.message) {
                    setMessage(response.data.message);
                    setData([]);
                    if (onDataLoaded) onDataLoaded();
                } else {
                    setTitle(response.data.title || "FPS Report");
                    setData(response.data.data || []);
                    setMessage("");
                }
            })
            .catch(error => {
                console.error("Error fetching FPS data:", error);
                setError(error)
                setData([]);
                setMessage("Internal error");
                setLoading(false);
            });

    }, [selectedMonth, selectedYear, afsoCode, distCode]);

    const calculateSchemeTotals = (schemeId) => {
        return data.reduce((sum, row) => {
            const found = row.schemeList?.find(s => s.scheme_id === schemeId);
            return {
                avail_cards: sum.avail_cards + (found?.avail_cards || 0),
                avail_trans: sum.avail_trans + (found?.avail_trans || 0),
                avail_port_cards: sum.avail_port_cards + (found?.avail_port_cards || 0),
                avail_port_trans: sum.avail_port_trans + (found?.avail_port_trans || 0),
            };
        }, { avail_cards: 0, avail_trans: 0, avail_port_cards: 0, avail_port_trans: 0 });
    };

    // ================= GRAND TOTALS =================
    const total_cards = data.reduce((sum, row) => sum + (row.total_cards || 0), 0);
    const totalAvailCards = data.reduce((sum, row) => sum + (row.avail_cards || 0), 0);
    const totalAvailTrans = data.reduce((sum, row) => sum + (row.avail_trans || 0), 0);
    const totalPortCards = data.reduce((sum, row) => sum + (row.avail_port_cards || 0), 0);
    const totalPortTrans = data.reduce((sum, row) => sum + (row.avail_port_trans || 0), 0);

    const totalAvailPercent = totalAvailCards
        ? ((totalPortCards * 100) / totalAvailCards).toFixed(2)
        : "0.00";

    const onFpsClick = (fpsId) => {
        setRenderContent(
            <div ref={nextTableRef}>
                <Portabilty_FPS_List
                    selectedMonth={selectedMonth}
                    selectedYear={selectedYear}
                    fpsId={fpsId}
                    afsoCode={afsoCode}
                    distCode={distCode}
                />
            </div>
        );
    };



      useEffect(() => {
    if (!loading && data.length > 0 && currentTableRef.current) {
        // Only scroll to the main table if it's the first load or year/month changed
        currentTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, data]);


    const handleDownload = () => {
        const tableSelect = document.getElementById('fpsReportTable');
        if (!tableSelect) return;
        const dataType = 'application/vnd.ms-excel';
        const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
        downloadLink.download = `fps_report_${afsoCode}.xls`;
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    //   useEffect(() => {
    //     if (!loading && !error && data.length > 0 && detailsRRef.current) {
    //       detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //     }
    //   }, [loading, error, data]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <Box><CircularProgress /></Box>
            </div>
        );
    }

    return (
        <div>
            {data.length > 0 ? (
                <table align="center" border={1} width="95%" id="fpsReportTable" ref={currentTableRef}>
                    <thead>
                        <tr className="tableheader">
                            <th colSpan={9 + schemeHeaders.length * 4}>{title}</th>
                        </tr>
                        <tr className="tableheader">
                            <th rowSpan={3}>Sl No</th>
                            <th rowSpan={3}>FPS ID</th>
                            <th rowSpan={3}>Dealer Name</th>
                            <th rowSpan={3}>Total Cards</th>

                            {schemeHeaders.map((sch, idx) => (
                                <th key={idx} colSpan={4}>{sch.scheme_short_name}</th>
                            ))}

                            <th colSpan={4}>TOTAL</th>
                            <th rowSpan={3}>% (Port Cards/Avail Cards)</th>
                        </tr>
                        <tr className="tableheader">
                            {schemeHeaders.map((_, idx) => (
                                <React.Fragment key={idx}>
                                    <th colSpan={2}>Regular</th>
                                    <th colSpan={2}>Portability</th>
                                </React.Fragment>
                            ))}
                            <th colSpan={2}>Regular</th>
                            <th colSpan={2}>Portability</th>
                        </tr>
                        <tr className="tableheader">
                            {schemeHeaders.map((_, idx) => (
                                <React.Fragment key={idx}>
                                    <th>Avail Cards</th>
                                    <th>Avail Trans</th>
                                    <th>Port Cards</th>
                                    <th>Port Trans</th>
                                </React.Fragment>
                            ))}
                            <th>Avail Cards</th>
                            <th>Avail Trans</th>
                            <th>Port Cards</th>
                            <th>Port Trans</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td onClick={() => onFpsClick(row.fps_id)} style={{ cursor: 'pointer', color: 'blue' }}>
                                    <u>{row.fps_id}</u>
                                </td>
                                <td>{row.del_name || "N/A"}</td>
                                <td style={{ textAlign: 'right' }}>{row.total_cards || 0}</td>

                                {schemeHeaders.map((sch, idx) => {
                                    const found = row.schemeList?.find(s => s.scheme_id === sch.scheme_id);
                                    return (
                                        <React.Fragment key={idx}>
                                            <td style={{ textAlign: 'right' }}>{found?.avail_cards || 0}</td>
                                            <td style={{ textAlign: 'right' }}>{found?.avail_trans || 0}</td>
                                            <td style={{ textAlign: 'right' }}>{found?.avail_port_cards || 0}</td>
                                            <td style={{ textAlign: 'right' }}>{found?.avail_port_trans || 0}</td>
                                        </React.Fragment>
                                    );
                                })}

                                <td style={{ textAlign: 'right' }}>{row.avail_cards || 0}</td>
                                <td style={{ textAlign: 'right' }}>{row.avail_trans || 0}</td>
                                <td style={{ textAlign: 'right' }}>{row.avail_port_cards || 0}</td>
                                <td style={{ textAlign: 'right' }}>{row.avail_port_trans || 0}</td>
                                <td style={{ textAlign: 'right' }}>
                                    {row.avail_cards ? ((row.avail_port_cards * 100) / row.avail_cards).toFixed(2) : "0.00"}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                    <tfoot>
                        <tr className="tableheader">
                            <th colSpan={3}>Total</th>
                            <th style={{ textAlign: 'right' }}>{total_cards}</th>
                            {schemeHeaders.map((sch, idx) => {
                                const sTotal = calculateSchemeTotals(sch.scheme_id);
                                return (
                                    <React.Fragment key={idx}>
                                        <th style={{ textAlign: 'right' }}>{sTotal.avail_cards}</th>
                                        <th style={{ textAlign: 'right' }}>{sTotal.avail_trans}</th>
                                        <th style={{ textAlign: 'right' }}>{sTotal.avail_port_cards}</th>
                                        <th style={{ textAlign: 'right' }}>{sTotal.avail_port_trans}</th>
                                    </React.Fragment>
                                );
                            })}
                            <th style={{ textAlign: 'right' }}>{totalAvailCards}</th>
                            <th style={{ textAlign: 'right' }}>{totalAvailTrans}</th>
                            <th style={{ textAlign: 'right' }}>{totalPortCards}</th>
                            <th style={{ textAlign: 'right' }}>{totalPortTrans}</th>
                            <th style={{ textAlign: 'right' }}>{totalAvailPercent}</th>
                        </tr>
                        <tr align="center">
                            <td colSpan={9 + schemeHeaders.length * 4}>
                                <button className="button button2" onClick={handleDownload}>Export to Excel</button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            ) : (
                <div align="center" className="mainhead">{message}</div>
            )}
            <br />
            {renderContent}
        </div>
    );
}

export default PortabilityFpsTable;